import {
  __name
} from "../../chunk-7QVYU63E.js";
import { TeamPlanTier } from "@alch/dx-entities";
import { CIO_TEAM_OBJECT_TYPE_ID } from "@alch/dx-entities/analytics/customerio";
import { omitBy } from "lodash-es";
function buildCustomerioUserTraits(user) {
  return omitBy({
    email: user.email?.toLowerCase(),
    firstName: user.firstName,
    lastName: user.lastName,
    team_id: user.teamId,
    is_billing_admin: user.isBillingAdmin,
    created_at: user.createdAt
  }, (val) => val == null);
}
__name(buildCustomerioUserTraits, "buildCustomerioUserTraits");
function buildCustomerioTeamTraits({ team, activePlan }) {
  return omitBy({
    objectTypeId: CIO_TEAM_OBJECT_TYPE_ID,
    name: team?.name,
    tier_name: activePlan?.tier ? TeamPlanTier[activePlan.tier] : void 0,
    created_at: team?.timeCreated
  }, (val) => val == null);
}
__name(buildCustomerioTeamTraits, "buildCustomerioTeamTraits");
export {
  buildCustomerioTeamTraits,
  buildCustomerioUserTraits
};
//# sourceMappingURL=customerio.js.map